import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';

import AboutReducer from './reducers/aboutReducer';
import ExperienceReducer from './reducers/experienceReducer';

import ArticlesReducer from './reducers/articlesReducer';
import KeywordsReducer from './reducers/keywordsReducer';
import SkillsReducer from './reducers/skillsReducer';
import InfoReducer from './reducers/infoReducer';
const thunkMiddleware = require('redux-thunk').default;


const reducers = combineReducers({
    experience: ExperienceReducer,
    about: AboutReducer,
    info: InfoReducer,
    articles: ArticlesReducer,
    keywords: KeywordsReducer,
    skills: SkillsReducer
});

const store = configureStore({
    reducer: reducers,
    middleware: [thunkMiddleware]
})

store.subscribe(() => {
    window._reduxState = store.getState();
})

export default store;